export default __webpack_public_path__ + "static/media/identity.2fbd90ba.svg";